import React, { Component } from 'react';
import ajax from 'utils/request';

const abortAjaxHoc = WrappedComponent => class extends Component {

    componentWillUnmount(){
        // this.abortControl();
    }

    abortableAjax = (type,url,params={},options={})=>{
        const {noAutoCatch,notAutoGoLogin} = options;
        return ajax(type,url,params,noAutoCatch,notAutoGoLogin);
    }

    render() {
        const props = Object.assign({},this.props);
        return (<WrappedComponent {...props} abortableAjax={this.abortableAjax} abortControl={this.abortControl}/>);
    }
};

export default abortAjaxHoc;



// WEBPACK FOOTER //
// ./src/components/abortAjaxHoc.js